import type { ContractSection, SignatureParty, SignatureSection } from './types';
import { genId } from './types';

/** 一方落款的默认行：中文单据最常见的三项。 */
export function defaultParty(label: string): SignatureParty {
  return {
    id: genId(),
    label,
    rows: [
      { id: genId(), label: '单位名称', fieldId: null, staticValue: '' },
      { id: genId(), label: '经办人', fieldId: null, staticValue: '' },
      { id: genId(), label: '日期', fieldId: null, staticValue: '' },
    ],
  };
}

/** 文档里所有签章区（含分栏里的），按出现顺序。 */
export function findSignatureSections(sections: ContractSection[]): SignatureSection[] {
  const out: SignatureSection[] = [];
  const walk = (list: ContractSection[]) => {
    for (const s of list) {
      if (s.type === 'signature') out.push(s);
      else if (s.type === 'columns') s.columns.forEach(walk);
    }
  };
  walk(sections);
  return out;
}

/** 深层替换一个签章区（可能在分栏里）。 */
export function replaceSignatureSection(sections: ContractSection[], next: SignatureSection): ContractSection[] {
  return sections.map((s) => {
    if (s.id === next.id) return next;
    if (s.type === 'columns') return { ...s, columns: s.columns.map((c) => replaceSignatureSection(c, next)) };
    return s;
  });
}

/** 给某一方盖上章；null = 去章。 */
export function sealParty(sections: ContractSection[], sectionId: string, partyId: string, dataUrl: string | null): ContractSection[] {
  const sec = findSignatureSections(sections).find((s) => s.id === sectionId);
  if (!sec) return sections;
  return replaceSignatureSection(sections, {
    ...sec,
    parties: sec.parties.map((p) => (p.id === partyId ? { ...p, sealDataUrl: dataUrl } : p)),
  });
}

/**
 * 文档末尾加一个只有我方的落款，靠右，章盖在上面。
 * 对账单、送货单、报价单的落款都是这个样子：右下角一个单位名 + 日期，章压在上面。
 */
export function appendSealedSignature(sections: ContractSection[], dataUrl: string): ContractSection[] {
  const party = { ...defaultParty('（盖章）'), sealDataUrl: dataUrl };
  party.rows = party.rows.filter((r) => r.label !== '经办人');
  return [...sections, { type: 'signature', id: genId(), align: 'right', parties: [party] }];
}
